import { render, staticRenderFns } from "./FinesView.vue?vue&type=template&id=8dde58b8"
import script from "./FinesView.vue?vue&type=script&lang=ts"
export * from "./FinesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports